/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { useState } from 'react';
import URLs from '../../../utilities/URLs';
import { staticBucketReachable } from 'redux/selectors';
import { connect } from 'react-redux';
import { IStore } from 'redux/storeType';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import StacklightsComponent from '../template/pubSub/StacklightsComponent';

function DetailGalleryPubSub(props: {
  templateContext: TemplateContext;
  machineId: string;
  colors?: string[];
  machineType?: string;
  defaultImagePathClassifier?: string;
  imagePath?: string;
  staticBucketReachable: boolean;
}) {
  const imagePath = URLs.getMachineImageBucket(props.imagePath, props.staticBucketReachable);
  const fallbackPath = URLs.getMachineImageBucketDefault(
    props.machineType,
    props.defaultImagePathClassifier,
    props.staticBucketReachable,
  );
  const [imagePathFailedOn, setImagePathFailedOn] = useState('');

  const shouldRetry = imagePathFailedOn !== imagePath;

  return (
    <div className="gallery mb-3 mb-lg-5">
      <div className="container">
        <img
          src={shouldRetry ? imagePath : fallbackPath}
          alt=""
          onError={() => {
            setImagePathFailedOn(imagePath);
          }}
        />
        {!shouldRetry && props.imagePath && <div className="text-mid">404</div>}
      </div>
      {props.templateContext && (
        <div className="stacklight">
          <StacklightsComponent templateContext={props.templateContext} />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state: IStore) => {
  return {
    staticBucketReachable: staticBucketReachable(state) || false,
  };
};

export default connect(mapStateToProps)(DetailGalleryPubSub);
